import { useEntityStore } from '@ContractBuilder/store';
import type { Attachment } from '@ContractBuilder/types';

export const useCurrentContractInlineAttachments = (): Attachment[] => {
  const submission = useEntityStore(({ submission }) => submission);
  return submission?.attachments?.filter((attachment) => attachment.block_id !== undefined) ?? [];
};
